export default "__VITE_ASSET__b2f2b6af__"